import React from "react";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import SetDefaultForm from "@/components/integrations/customer-defaults/SetDefaultForm";

interface Props {
  isOpen: boolean;
  customerId?: string;
  onDismiss: () => void;
  onSave: () => void;
}

const SetDefaultPanel = (props: Props) => {
  return (
    <RigthPanel
      header="Set Default Integration"
      isOpen={props.isOpen}
      type={RigthPanelType.small}
      dismissPanel={props.onDismiss}
      childComponent={SetDefaultForm}
      childProps={{
        customerId: props.customerId,
        onSave: props.onSave,
        onClose: props.onDismiss,
      }}
    />
  );
};

export default SetDefaultPanel;
